import {
  ADD_OBJECTS_TO_CANVAS,
  START,
  SUCCESS,
  FAIL
} from "../constants/action-types";
import Mediator from "../services/Mediator";
import isDarkColor from "../services/lib/is-dark-color";

const isDarkDesign = (design) => {
  return design && design.background && isDarkColor(design.background);
};

const isBlackProduct = (variants) => {
  return variants && variants.color === `black`;
};

export const addObjectsToCanvas = (params, options = {}) => (
  dispatch,
  getState
) => {
  dispatch({
    type: ADD_OBJECTS_TO_CANVAS + START
  });
  (async () => {
    const {
      condition: {variants, design}
    } = getState();
    try {
      let fill;
      if (options.fill) {
        fill = options.fill;
      } else {
        fill =
          isBlackProduct(variants) || isDarkDesign(design) ? `#fff` : `#000`;
      }
      await Mediator.addObjectsToCanvas(params, {
        ...options,
        fill
      });
      dispatch({
        type: ADD_OBJECTS_TO_CANVAS + SUCCESS
      });
    } catch (e) {
      dispatch({
        type: ADD_OBJECTS_TO_CANVAS + FAIL,
        error: `Произошла ошибка`
      });
      throw e;
    }
  })();
};
